"use strict";

var _objectSpread = require("/Users/fangyu/Code/unifygama/metacrm/metadesk-frontend/node_modules/@babel/runtime/helpers/objectSpread2.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defineFormatter = void 0;
function defineFormatter(type, format) {
  return _ref => {
    let {
      exclude,
      format: overrides
    } = _ref;
    return {
      exclude,
      format: args => {
        const formatted = format(args);
        if (exclude) {
          for (const key of exclude) {
            delete formatted[key];
          }
        }
        return _objectSpread(_objectSpread({}, formatted), overrides(args));
      },
      type
    };
  };
}
exports.defineFormatter = defineFormatter;
//# sourceMappingURL=formatter.js.map